const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m.25 7.21 11 12.47a1.06 1.06 0 0 0 1.54 0l11-12.47a1 1 0 0 0 .21-.73 1 1 0 0 0-.36-.69l-1.85-1.55a1 1 0 0 0-.74-.24 1 1 0 0 0-.69.35l-8.17 9.45a.27.27 0 0 1-.38 0L3.64 4.35A1 1 0 0 0 3 4a1 1 0 0 0-.74.23L.36 5.79a1 1 0 0 0-.36.69 1 1 0 0 0 .25.73Z" fill="currentColor"></path></svg>';
export {
  a as default
};
